import { QueryFunctionContext } from '@tanstack/react-query';
import axios from 'axios';
import { APIBoxFormVariable } from 'components/module/cards/APIBoxCard';
import { GptBoxFormVariable } from 'components/module/cards/GPTBoxCard';
import { NumbersFormVariables } from 'components/module/cards/NumbersCard';
import {
  API_BOX_API_URL,
  CALCULATOR_API_URL,
  CUSTOM_NUMERIC_API_URL,
  GPT_BOX_API_URL,
  MODULE_API_URL,
  MODULE_TYPES,
  NUMERICS_API_URL,
  TEXT_INPUT_API_URL,
  VALUE_PANEL_API_URL,
} from '../constants';

export const GptBoxApi = {
  get: () => {},
  post: (data: GptBoxFormVariable) => axios.post(GPT_BOX_API_URL, data).then((res) => res.data),
  patch: (gptboxId: Number, data: GptBoxFormVariable) =>
    axios.patch(`${GPT_BOX_API_URL}${gptboxId}/`, data).then((res) => res.data),
  delete: () => {},
};

export const NumbersAPI = {
  post: (data: NumbersFormVariables) =>
    axios.post(VALUE_PANEL_API_URL, data).then((res) => res.data),
  patch: (elementId: number, data: NumbersFormVariables) =>
    axios.patch(`${VALUE_PANEL_API_URL}${elementId}/`, data).then((res) => res.data),
  getGlobalNumbers: () => axios.get(NUMERICS_API_URL).then((res) => res.data),
  getCustomNumbers: ({ queryKey }: QueryFunctionContext) =>
    axios
      .get(
        `${queryKey[0] === MODULE_TYPES.ALGO ? MODULE_API_URL : CALCULATOR_API_URL}${queryKey[1]}/custom_numerics`
      )
      .then((res) => res.data),
  getCustomNumber: ({ queryKey }: QueryFunctionContext) =>
    axios.get(CUSTOM_NUMERIC_API_URL + queryKey[1] + '/').then((res) => res.data),
  postCustomNumber: (data) => axios.post(CUSTOM_NUMERIC_API_URL, data).then((res) => res.data),
  patchCustomNumber: (customNumberId, data) =>
    axios.patch(CUSTOM_NUMERIC_API_URL + customNumberId + '/', data).then((res) => res.data),
};

export const ApiBoxAPI = {
  post: (data: APIBoxFormVariable) => axios.post(API_BOX_API_URL, data).then((res) => res.data),
  patch: (elementId: number, data: APIBoxFormVariable) =>
    axios.patch(`${API_BOX_API_URL}${elementId}/`, data).then((res) => res.data),
};

export const TextInputAPI = {
  post: (data: any) => axios.post(TEXT_INPUT_API_URL, data).then((res) => res.data),
  patch: (elementId: number, data: any) =>
    axios.patch(`${TEXT_INPUT_API_URL}${elementId}/`, data).then((res) => res.data),
};
